import { Toast } from '@loophealth/loop-ui-web-library';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addFTUShownUserIds } from '../../../redux/slices/ApplicationStateSlice';
import { selectFTUShownUserIds } from '../../../redux/slices/ApplicationStateSlice/selectors';
import { FlagsmithFlags, useFeatureFlag } from '../../../utils/flagsmith';
import EmptyPageLoader from '../../atoms/EmptyPageLoader';
import {
    selectUserAttributes,
    selectUserData,
    selectUserId
} from '../../pages/LoginContainer/redux/slices/UserSlice/selectors';
import { getUserAttributes } from '../../pages/LoginContainer/redux/slices/UserSlice/thunks';
import UserAttributesModal from '../Dashboard/UserAttributesModal';
import OnboardingScreenFtux from '../OnboardingScreenFtux';

const OnboardingFlowSequence: React.FC = ({ children }) => {
    const toast = Toast.useToast();
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const user = useSelector(selectUserData);
    const ftuxShownUserIds = useSelector(selectFTUShownUserIds);
    const userAttributes = useSelector(selectUserAttributes);
    const isUserAttributesEnabled = useFeatureFlag(FlagsmithFlags.USER_ATTRIBUTES);

    const showFtux = !!userId && !ftuxShownUserIds.includes(userId);
    const [showUserAttributesModal, setShowUserAttributesModal] = React.useState(false);
    const isFetched = React.useRef(false);

    React.useEffect(() => {
        if (!isUserAttributesEnabled || !userId) return;
        if (!isFetched.current) {
            if (userAttributes?.data) return;
            dispatch(getUserAttributes({ userId }));
            isFetched.current = true;
        } else if (!userAttributes?.loading && !userAttributes?.error && userAttributes?.data?.isQuestionnairePending) {
            setShowUserAttributesModal(true);
        } else if (userAttributes.error) {
            toast?.error(userAttributes.error?.message || 'Something went wrong');
        }
    }, [isUserAttributesEnabled, userAttributes, userId, dispatch]);

    const handleFtuxClose = () => {
        dispatch(addFTUShownUserIds(userId));
    };

    return (
        <>
            {showFtux ? (
                <OnboardingScreenFtux onClose={handleFtuxClose} />
            ) : showUserAttributesModal ? (
                <Toast.ToastContainer showCloseIcon={true} maxWidth="800px">
                    <UserAttributesModal setIsVisible={setShowUserAttributesModal} />
                </Toast.ToastContainer>
            ) : user.loading || !user.data ? (
                <EmptyPageLoader />
            ) : (
                children
            )}
        </>
    );
};

export default OnboardingFlowSequence;
